import React from 'react';
import { ROUTE_LINKS } from '../data/routePages';
import { carrierName, cheapest, cheapestExpress, checkedText, country, inr } from '../lib/rates';

// Homepage comparison table: what a 1 kg parcel costs on the busiest routes,
// cheapest and express, with links to each route page and the calculator.
// Prices come from the rates.json snapshot, so they are in the static HTML.
const ROWS = ['uk', 'usa', 'canada', 'australia', 'uae'];

const HomeRoutesSection = () => (
  <section className="py-16 bg-slate-50" aria-labelledby="home-routes-title">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-10">
        <h2 id="home-routes-title" className="text-3xl font-bold text-slate-900 mb-4">
          International courier rates from India
        </h2>
        <p className="text-lg text-slate-600 max-w-2xl mx-auto">
          {'Our international courier services compare DHL, FedEx, UPS, India Post and SendMyParcel’s own services '
            + 'on every booking. Here is what a 1 kg parcel cost on the busiest routes.'}
        </p>
      </div>
      {/* relative: the sr-only header label is absolutely positioned and would
          otherwise escape the scroll box and widen the page on phones. */}
      <div className="relative overflow-x-auto rounded-xl border border-slate-200 bg-white">
        <table className="w-full min-w-[600px] border-collapse text-sm" data-test="home-rates">
          <thead>
            <tr className="bg-[#0A1128] text-white">
              <th scope="col" className="text-left p-3">Destination</th>
              <th scope="col" className="text-left p-3">Cheapest 1 kg</th>
              <th scope="col" className="text-left p-3">Express 1 kg</th>
              <th scope="col" className="p-3"><span className="sr-only">Route page</span></th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map((key, i) => {
              const c = country(key);
              const low = cheapest(key, 1);
              const fast = cheapestExpress(key, 1);
              const link = ROUTE_LINKS[key];
              return (
                <tr key={key} className={i % 2 ? 'bg-white' : 'bg-slate-50'}>
                  <th scope="row" className="text-left p-3 font-semibold text-slate-800">{c.name}</th>
                  <td className="p-3 text-slate-700">
                    <span className="font-semibold">{inr(low.price)}</span>{' '}
                    <span className="text-slate-500">{carrierName(low.carrier)}</span>
                  </td>
                  <td className="p-3 text-slate-700">
                    {fast ? (
                      <>
                        <span className="font-semibold">{inr(fast.price)}</span>{' '}
                        <span className="text-slate-500">{`${fast.carrier}${fast.transit ? `, ${fast.transit}` : ''}`}</span>
                      </>
                    ) : '—'}
                  </td>
                  <td className="p-3 text-right">
                    {link ? (
                      <a href={link.href} className="text-[#F17221] font-semibold hover:underline whitespace-nowrap">
                        {`${link.label} rates →`}
                      </a>
                    ) : null}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p className="mt-3 text-sm text-slate-500 text-center">
        {`Prices checked ${checkedText}; your live quote may differ. `}
        <a href="/shipping-rates-calculator/" className="text-[#F17221] font-semibold hover:underline">Shipping calculator</a>
        {' · '}
        <a href="/send-courier-from-india-to-europe/" className="text-[#F17221] font-semibold hover:underline">India to Europe</a>
        {' · '}
        <a href="/international-shipping-india/" className="text-[#F17221] font-semibold hover:underline">All destinations</a>
        {' · '}
        <a href="/quote/" className="text-[#F17221] font-semibold hover:underline">Get a quote</a>
      </p>
    </div>
  </section>
);

export default HomeRoutesSection;
